module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RecordListView.js"));
	}, "NameRecordListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NameRecordListView!./src/pages/Promote/BusinessHall/AlterName/RecordList/RecordListView.js
// module id = 1647
// module chunks = 418